import { connect } from 'react-redux'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  messages: ['Why would you like to decline the lease?'],

  actions: [],
})

const mapDispatchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBot)
